export default "__VITE_ASSET__DxkNWPa7__"